// import {
//   NavigationMenu,
//   NavigationMenuContent,
//   NavigationMenuItem,
//   NavigationMenuLink,
//   NavigationMenuList,
//   NavigationMenuTrigger
// } from '@/components/ui/navigation-menu';
// import { Button } from '@/components/ui/button';
// import { Link, useLocation } from 'wouter';
// import { Search, Calendar, Menu, FileText, Layout, Globe, X } from 'lucide-react';
// import { Drawer, DrawerContent, DrawerTrigger, DrawerClose } from '@/components/ui/drawer';
// import { useState, useEffect } from 'react';
// import { useAuth } from '@/hooks/use-auth';
// import { cn } from '@/lib/utils';

// // Update this constant with your desired website URL
// const WEBSITE_URL = 'http://localhost:8000'; // Replace with your actual website URL

// const navItems = [
//   { label: 'Home', href: WEBSITE_URL },
//   // { label: 'Our Process', href: '/process' },
//   { label: 'Blog', href: '/blog' },
//   { label: 'Contact', href: '/contact' }
// ];

// export default function Navigation() {
//   const [isOpen, setIsOpen] = useState(false);
//   const [location] = useLocation();
//   const [scrolled, setScrolled] = useState(false);
//   const { user } = useAuth();

//   const handleNavigate = () => {
//     window.scrollTo({ top: 0, behavior: 'smooth' });
//     setIsOpen(false);
//   };

//   // Add scroll detection for navigation styling
//   useEffect(() => {
//     const handleScroll = () => {
//       setScrolled(window.scrollY > 10);
//     };

//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   const shouldShowBookButton = location !== '/book';

//   // Navigation link component to avoid repetition
//   const NavLink = ({ href, label, onClick = handleNavigate }: { href: string; label: string; onClick?: () => void }) => (
//     <Link href={href}>
//       <a
//         className={cn(
//           'flex items-center gap-2 px-4 py-2 text-sm font-medium transition-colors',
//           'hover:text-primary',
//           location === href ? 'text-primary' : 'text-foreground/80'
//         )}
//         onClick={onClick}
//       >
//         {/* {Icon && <Icon className="h-4 w-4" />} */}
//         {label}
//       </a>
//     </Link>
//   );

//   return (
//     <header
//       className={cn(
//         'sticky top-0 z-50 w-full transition-all duration-200',
//         scrolled ? 'border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 shadow-sm' : 'bg-transparent'
//       )}
//     >
//       <div className="container flex h-16 items-center justify-between">
//         <Link href={WEBSITE_URL}>
//           <span className="flex items-center space-x-2 cursor-pointer" onClick={handleNavigate}>
//             <Search className="h-6 w-6 text-primary" />
//             <span className="text-xl font-bold">DataFirst SEO</span>
//           </span>
//         </Link>

//         {/* Desktop Navigation */}
//         <nav className="hidden md:flex items-center space-x-6">
//           {navItems.map((item) => (
//             <NavLink key={item.href} href={item.href} label={item.label} />
//           ))}

//           <div className="mx-2 h-4 w-px bg-border" />

//           {user ? (
//             <Link href="/admin">
//               <Button variant="ghost" onClick={handleNavigate}>
//                 Admin Dashboard
//               </Button>
//             </Link>
//           ) : (
//             shouldShowBookButton && (
//               <Link href="/book">
//                 <Button className="shadow-sm" onClick={handleNavigate}>
//                   <Calendar className="mr-2 h-4 w-4" />
//                   Book Free Consultation
//                 </Button>
//               </Link>
//             )
//           )}
//         </nav>

//         {/* Mobile Menu */}
//         <div className="flex items-center md:hidden">
//           <Drawer open={isOpen} onOpenChange={setIsOpen}>
//             <DrawerTrigger asChild>
//               <Button variant="ghost" size="icon" aria-label="Menu">
//                 <Menu className="h-6 w-6" />
//               </Button>
//             </DrawerTrigger>
//             <DrawerContent className="h-[80vh]">
//               <div className="px-4 py-6 h-full flex flex-col">
//                 <div className="flex items-center justify-between mb-8">
//                   <div className="flex items-center gap-2">
//                     <Search className="h-5 w-5 text-primary" />
//                     <span className="text-lg font-bold">DataFirst SEO</span>
//                   </div>
//                   <DrawerClose asChild>
//                     <Button variant="ghost" size="icon">
//                       <X className="h-5 w-5" />
//                     </Button>
//                   </DrawerClose>
//                 </div>

//                 <nav className="flex flex-col gap-4">
//                   <NavLink href={WEBSITE_URL} label="Home" />
//                   {/* <NavLink href="/process" label="Our Process" icon={Layout} /> */}
//                   <NavLink href="/blog" label="Blog" />
//                   <NavLink href="/contact" label="Contact" />
//                 </nav>

//                 <div className="mt-8">
//                   {user ? (
//                     <Link href="/admin">
//                       <Button className="w-full" onClick={handleNavigate}>
//                         Admin Dashboard
//                       </Button>
//                     </Link>
//                   ) : (
//                     shouldShowBookButton && (
//                       <Link href="/book">
//                         <Button className="w-full" onClick={handleNavigate}>
//                           <Calendar className="mr-2 h-4 w-4" />
//                           Book Free Consultation
//                         </Button>
//                       </Link>
//                     )
//                   )}
//                 </div>
//               </div>
//             </DrawerContent>
//           </Drawer>
//         </div>
//       </div>
//     </header>
//   );
// }

// import {
//   NavigationMenu,
//   NavigationMenuContent,
//   NavigationMenuItem,
//   NavigationMenuLink,
//   NavigationMenuList,
//   NavigationMenuTrigger
// } from '@/components/ui/navigation-menu';
// import { Button } from '@/components/ui/button';
// import { Link, useLocation } from 'wouter';
// import { Search, Calendar, Menu, FileText, Layout, Globe, X } from 'lucide-react';
// import { Drawer, DrawerContent, DrawerTrigger, DrawerClose } from '@/components/ui/drawer';
// import { useState, useEffect } from 'react';
// import { useAuth } from '@/hooks/use-auth';
// import { cn } from '@/lib/utils';

// // Update this constant with your desired website URL
// const WEBSITE_URL = 'http://localhost:8000'; // Replace with your actual website URL

// const navItems = [
//   { label: 'Home', href: WEBSITE_URL, external: true },
//   // { label: 'Our Process', href: '/process', external: false },
//   { label: 'Blog', href: '/blog', external: false },
//   { label: 'Contact', href: '/contact', external: false }
// ];

// export default function Navigation() {
//   const [isOpen, setIsOpen] = useState(false);
//   const [location] = useLocation();
//   const [scrolled, setScrolled] = useState(false);
//   const { user } = useAuth();

//   const handleNavigate = () => {
//     window.scrollTo({ top: 0, behavior: 'smooth' });
//     setIsOpen(false);
//   };

//   // Add scroll detection for navigation styling
//   useEffect(() => {
//     const handleScroll = () => {
//       setScrolled(window.scrollY > 10);
//     };

//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   const shouldShowBookButton = location !== '/book';

//   // Navigation link component that supports both internal and external links
//   const NavLink = ({
//     href,
//     label,
//     external = false,
//     onClick = handleNavigate
//   }: {
//     href: string;
//     label: string;
//     external?: boolean;
//     onClick?: () => void;
//   }) => {
//     if (external) {
//       return (
//         <a
//           href={href}
//           className={cn('flex items-center gap-2 px-4 py-2 text-sm font-medium transition-colors', 'hover:text-primary', 'text-foreground/80')}
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           {label}
//         </a>
//       );
//     }

//     return (
//       <Link href={href}>
//         <a
//           className={cn(
//             'flex items-center gap-2 px-4 py-2 text-sm font-medium transition-colors',
//             'hover:text-primary',
//             location === href ? 'text-primary' : 'text-foreground/80'
//           )}
//           onClick={onClick}
//         >
//           {label}
//         </a>
//       </Link>
//     );
//   };

//   return (
//     <header
//       className={cn(
//         'sticky top-0 z-50 w-full transition-all duration-200',
//         scrolled ? 'border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 shadow-sm' : 'bg-transparent'
//       )}
//     >
//       <div className="container flex h-16 items-center justify-between">
//         {/* Logo as an external link */}
//         <a href={WEBSITE_URL} className="flex items-center space-x-2 cursor-pointer">
//           <Search className="h-6 w-6 text-primary" />
//           <span className="text-xl font-bold">DataFirst SEO</span>
//         </a>

//         {/* Desktop Navigation */}
//         <nav className="hidden md:flex items-center space-x-6">
//           {navItems.map((item) => (
//             <NavLink key={item.href} href={item.href} label={item.label} external={item.external} />
//           ))}

//           <div className="mx-2 h-4 w-px bg-border" />

//           {user ? (
//             <Link href="/admin">
//               <Button variant="ghost" onClick={handleNavigate}>
//                 Admin Dashboard
//               </Button>
//             </Link>
//           ) : (
//             shouldShowBookButton && (
//               <Link href="/book">
//                 <Button className="shadow-sm" onClick={handleNavigate}>
//                   <Calendar className="mr-2 h-4 w-4" />
//                   Book Free Consultation
//                 </Button>
//               </Link>
//             )
//           )}
//         </nav>

//         {/* Mobile Menu */}
//         <div className="flex items-center md:hidden">
//           <Drawer open={isOpen} onOpenChange={setIsOpen}>
//             <DrawerTrigger asChild>
//               <Button variant="ghost" size="icon" aria-label="Menu">
//                 <Menu className="h-6 w-6" />
//               </Button>
//             </DrawerTrigger>
//             <DrawerContent className="h-[80vh]">
//               <div className="px-4 py-6 h-full flex flex-col">
//                 <div className="flex items-center justify-between mb-8">
//                   <div className="flex items-center gap-2">
//                     <Search className="h-5 w-5 text-primary" />
//                     <span className="text-lg font-bold">DataFirst SEO</span>
//                   </div>
//                   <DrawerClose asChild>
//                     <Button variant="ghost" size="icon">
//                       <X className="h-5 w-5" />
//                     </Button>
//                   </DrawerClose>
//                 </div>

//                 <nav className="flex flex-col gap-4">
//                   {navItems.map((item) => (
//                     <NavLink key={item.href} href={item.href} label={item.label} external={item.external} />
//                   ))}
//                 </nav>

//                 <div className="mt-8">
//                   {user ? (
//                     <Link href="/admin">
//                       <Button className="w-full" onClick={handleNavigate}>
//                         Admin Dashboard
//                       </Button>
//                     </Link>
//                   ) : (
//                     shouldShowBookButton && (
//                       <Link href="/book">
//                         <Button className="w-full" onClick={handleNavigate}>
//                           <Calendar className="mr-2 h-4 w-4" />
//                           Book Free Consultation
//                         </Button>
//                       </Link>
//                     )
//                   )}
//                 </div>
//               </div>
//             </DrawerContent>
//           </Drawer>
//         </div>
//       </div>
//     </header>
//   );
// }

// import { Search } from 'lucide-react';
// import { useState, useEffect } from 'react';
// import { cn } from '@/lib/utils';

// // Website URL constant
// const WEBSITE_URL = 'http://localhost:8000';

// export default function Navigation() {
//   const [scrolled, setScrolled] = useState(false);

//   // Add scroll detection for navigation styling
//   useEffect(() => {
//     const handleScroll = () => {
//       setScrolled(window.scrollY > 10);
//     };

//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   return (
//     <header
//       className={cn(
//         'sticky top-0 z-50 w-full transition-all duration-200',
//         scrolled ? 'border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 shadow-sm' : 'bg-transparent'
//       )}
//     >
//       <div className="container flex h-16 items-center justify-between">
//         {/* Logo as an external link */}
//         <a href={WEBSITE_URL} className="flex items-center space-x-2 cursor-pointer">
//           <Search className="h-6 w-6 text-primary" />
//           <span className="text-xl font-bold">DataFirst SEO</span>
//         </a>
//       </div>
//     </header>
//   );
// }

import { useState, useEffect } from 'react';
import { cn } from '@/lib/utils';

// Website URL constant
// const WEBSITE_URL = 'http://localhost:8000'; // Replace with your actual website URL
const WEBSITE_URL = 'https://datafirstseo.com';

export default function Navigation() {
  const [scrolled, setScrolled] = useState(false);

  // Add scroll detection for navigation styling
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav id='navbar' className={cn('sticky top-0 z-50 w-full px-6 py-4', scrolled ? 'bg-white shadow-lg' : 'bg-transparent')}>
      <div className='container mx-auto flex justify-between items-center'>
        {/* Logo as an external link */}
        <a href={WEBSITE_URL} className='flex items-center'>
          <div className='text-3xl'>
            {/* <span className="text-blue-600">Data</span>
            <span className="text-gray-800">First</span> */}
            <span className='text-gray-800  font-bold'>DataFirst</span>
            <span className='text-sm'> </span>
            <span className='text-blue-600'>SEO</span>
          </div>
        </a>
      </div>
    </nav>
  );
}
